// Banana hash-route helper placeholders. Kept here (rather than only in the
// banana-only constants file) so universal code can build the same hash-route
// patterns without depending on banana packages.
export const ITINERARY_ID_PLACEHOLDER = ':itineraryId';
export const RESULT_INDEX = ':resultIndex';

// Banana booking-panel modal hash route.
export const DETAILS = `#/details/${ITINERARY_ID_PLACEHOLDER}/index/${RESULT_INDEX}`;

export const CONFIG_PATH_SEGMENT = 'config/';

export const CONFIG = `*/${CONFIG_PATH_SEGMENT}:itineraryId`;

export const CONFIG_SUFFIX = `/${CONFIG_PATH_SEGMENT}:itineraryId`;

export const ITINERARY_PATH_SEGMENT = 'itinerary/';

export const ITINERARY_SUFFIX = `/${ITINERARY_PATH_SEGMENT}:itineraryId`;

// Acorn Book It For Me page route segment/suffix (sibling of the config route).
export const BIFM_PATH_SEGMENT = 'bifm/';

export const BIFM_SUFFIX = `/${BIFM_PATH_SEGMENT}:itineraryId`;

export const DAYVIEW = [
  '/:transport/d/:origin1/:departure1/:dest1',
  '/:transport/d/:origin1/:departure1/:dest1/:origin2/:departure2/:dest2',
  '/:transport/d/:origin1/:departure1/:dest1/:origin2/:departure2/:dest2/:origin3/:departure3/:dest3',
  '/:transport/d/:origin1/:departure1/:dest1/:origin2/:departure2/:dest2/:origin3/:departure3/:dest3/:origin4/:departure4/:dest4',
  '/:transport/d/:origin1/:departure1/:dest1/:origin2/:departure2/:dest2/:origin3/:departure3/:dest3/:origin4/:departure4/:dest4/:origin5/:departure5/:dest5',
  '/:transport/d/:origin1/:departure1/:dest1/:origin2/:departure2/:dest2/:origin3/:departure3/:dest3/:origin4/:departure4/:dest4/:origin5/:departure5/:dest5/:origin6/:departure6/:dest6',
  '/:transport/:flights/:origin/:dest/:departure/:return',
  '/:transport/:flights/:origin/:dest/:departure',
];
